export enum OrderMarketType {
    NORMAL = 'normal', // 普通市场
    BLOCK = 'block', // 区块链,
}


/** 订单是否可以拆分 */
export enum OrderType {
    /** 可拆分 */
    SEPARABLY = 1,
    /** 不可拆分 */
    INSEPARABLY = 0,
}

